import { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { withNamespaces } from 'react-i18next';
import { Button, Spinner } from 'reactstrap';

export const MAILER_SETTINGS_FORM_ID = 'mailer-settings-form';

const FormActions = ({
    t,
    isFetching,
    isFirstTime,
    submitMutation,
    testConnectionMutation,
    onTestConnection,
}) => {
    const actionsRef = useRef(null);
    const [isActionsVisible, setIsActionsVisible] = useState(false);

    useLayoutEffect(() => {
        const form = document.getElementById(MAILER_SETTINGS_FORM_ID);
        const pane = form?.closest('.tab-pane');

        if (!pane) {
            setIsActionsVisible(true);
            return undefined;
        }

        const syncVisibility = () => {
            const nextVisible = pane.classList.contains('active');

            setIsActionsVisible((current) => (
                current === nextVisible ? current : nextVisible
            ));
        };

        syncVisibility();

        const observer = new MutationObserver(syncVisibility);
        observer.observe(pane, {
            attributes: true,
            attributeFilter: ['class'],
        });

        return () => observer.disconnect();
    }, []);

    useLayoutEffect(() => {
        const bar = actionsRef.current;
        const footer = document.querySelector('.footer');

        if (!isActionsVisible || !bar || !footer) {
            return undefined;
        }

        const pinToFooter = () => {
            const overlap = Math.max(0, window.innerHeight - footer.getBoundingClientRect().top);
            bar.style.bottom = `${overlap}px`;
        };

        pinToFooter();
        window.addEventListener('scroll', pinToFooter, { passive: true });
        window.addEventListener('resize', pinToFooter);

        return () => {
            window.removeEventListener('scroll', pinToFooter);
            window.removeEventListener('resize', pinToFooter);
        };
    }, [isActionsVisible]);

    if (typeof document === 'undefined' || !isActionsVisible) {
        return null;
    }

    return createPortal(
        <div
            ref={actionsRef}
            className="mailer-settings__actions"
        >
            {!isFirstTime && (
                <Button
                    type="button"
                    color="secondary"
                    outline
                    onClick={onTestConnection}
                    disabled={
                        isFetching ||
                        submitMutation.isLoading ||
                        testConnectionMutation.isLoading
                    }
                >
                    {testConnectionMutation.isLoading && (
                        <Spinner size="sm" className="me-2" />
                    )}
                    {t('Test Connection')}
                </Button>
            )}

            <Button
                color="primary"
                type="submit"
                form={MAILER_SETTINGS_FORM_ID}
                disabled={isFetching || submitMutation.isLoading}
            >
                {submitMutation.isLoading && (
                    <Spinner size="sm" className="me-2" />
                )}
                {t('Save Changes')}
            </Button>
        </div>,
        document.body
    );
};

export default withNamespaces()(FormActions);
